import React from 'react';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { DialogContentText } from '@material-ui/core';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  root: {
    margin: 0,
    // padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyle = makeStyles((theme) => ({
  creditImage: {
    fontSize: 12,
    color: theme.text.primary,
    display: 'block',
  },
  link: {
    fontSize: 16,
    color: theme.text.primary,
    display: 'block',
    '&:hover': {
      color: theme.ui.primary,
    },
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export const CreditImage = ({ open, setOpen }) => {
  const classes = useStyle();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Link className={classes.creditImage} onClick={handleClickOpen}>
        Image Credit
      </Link>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <DialogTitle id='customized-dialog-title' onClose={handleClose}>
          Credit image
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id='alert-dialog-slide-description'>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/business'
            >
              https://storyset.com/business
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/people'
            >
              https://storyset.com/people
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/food'
            >
              https://storyset.com/food
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/work'
            >
              https://storyset.com/work
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/event'
            >
              https://storyset.com/event
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/event'
            >
              https://storyset.com/event
            </a>
            <a
              className={classes.link}
              target='_blank'
              rel='noreferrer'
              href='https://storyset.com/people'
            >
              https://storyset.com/people
            </a>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
